// Local-only adapter. No network calls; replace this boundary for server sync.
const openStore = () => new Promise((resolve, reject) => {
  const request = indexedDB.open('fox-moments-v1', 1);
  request.onupgradeneeded = () => request.result.createObjectStore('moments', {keyPath: 'id'});
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});
async function transaction(mode, action) {
  const db = await openStore();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('moments', mode);
    const request = action(tx.objectStore('moments'));
    tx.oncomplete = () => { db.close(); resolve(request.result); };
    tx.onerror = () => { db.close(); reject(tx.error); };
    tx.onabort = () => { db.close(); reject(tx.error || new Error('Storage aborted')); };
  });
}
export const momentsService = {
  async list(ownerId) {
    const rows = await transaction('readonly', store => store.getAll());
    return rows.filter(row => row.ownerId === ownerId && row.expiresAt > Date.now()).sort((a,b) => b.createdAt-a.createdAt);
  },
  async create(ownerId, author, media, caption) {
    if (!media || (!media.type.startsWith('image/') && !media.type.startsWith('video/'))) {
      throw new Error('Выберите фото или видео для момента.');
    }
    const limit = media.type.startsWith('video/') ? 25*1024*1024 : 10*1024*1024;
    if (media.size > limit) {
      throw new Error(media.type.startsWith('video/') ? 'Видео не должно быть больше 25 МБ.' : 'Фото не должно быть больше 10 МБ.');
    }
    const row = {id: crypto.randomUUID(), ownerId, author, media, caption: caption.trim().slice(0, 500),
      mediaType: media.type.startsWith('video/') ? 'video' : 'image', createdAt: Date.now(), expiresAt: Date.now()+86400000, viewed: false, audience: 'local-only'};
    await transaction('readwrite', store => store.put(row));
    return row;
  },

  async createText(ownerId, author, text, background = 'sunset') {
    const value = String(text || '').trim().slice(0, 500);

    if (!value) {
      throw new Error('Напишите текст момента.');
    }

    const allowed = ['sunset', 'night', 'ocean', 'berry', 'forest', 'ember'];
    const safeBackground = allowed.includes(background) ? background : 'sunset';

    const row = {
      id: crypto.randomUUID(),
      ownerId,
      author,
      media: null,
      caption: '',
      text: value,
      background: safeBackground,
      mediaType: 'text',
      createdAt: Date.now(),
      expiresAt: Date.now() + 86400000,
      viewed: false,
      audience: 'local-only'
    };

    await transaction('readwrite', store => store.put(row));
    return row;
  },
  async markViewed(row) { await transaction('readwrite', store => store.put({...row, viewed: true})); },
  async remove(id) { await transaction('readwrite', store => store.delete(id)); }
};
